module.exports = __webpack_public_path__ + "static/media/krx-trading-krx-02.50c1d39b.jpg";